<script>
export default {
  name: 'BasePage',
  data() {
    return {
      quarterWindowHeight: (window.innerHeight / 4),
      thirdWindowHeight: (window.innerHeight / 3),
      halfWindowHeight: (window.innerHeight / 2),
      twoThirdWindowHeight: (window.innerHeight / 3) * 2,
      offsetWindowHeight: null,
      searching: false,
      total: 0,
      rows: [],
      pageSizes: [100, 200, 400],
      pageSize: 100,
      pageNumber: 1,
      orderBy: null,
      initRows: true,
      enterSearch: true,
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getRows(this.pageNumber, this.pageSize);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRows(this.pageNumber, this.pageSize);
    },
    indexMethod(index) {
      let offset = this.pageSize * (this.pageNumber - 1);
      return index + offset + 1;
    },
    handleSortChange({column, prop, order}) {
      if (order === 'ascending') {
        this.orderBy = prop;
      } else if (order === 'descending') {
        this.orderBy = prop + ' desc';
      } else {
        this.orderBy = null;
      }
      this.getRows(this.pageNumber, this.pageSize);
    },
    getRows(pageNumber, pageSize) {
      this.pageNumber = isNaN(pageNumber) ? 1 : pageNumber;
      this.pageSize = isNaN(pageSize) ? this.pageSize : pageSize;
      this.$message.error("请实现 getRows() 方法");
    },
  },
  mounted() {
    let basePageTable = null;
    if (this.$refs.basePageTable) {
      basePageTable = this.$refs.basePageTable;
    }
    if (basePageTable && basePageTable.$options) {
      // 自适应表格高度
      let tableHeight = 0;
      if (basePageTable.$options.propsData.height) {
        tableHeight = basePageTable.$options.propsData.height + "";
        if (tableHeight.indexOf('px') >= 0) {
          tableHeight = parseInt(tableHeight.replace('px', ''));
        }
      } else {
        let el = basePageTable.$el ? basePageTable.$el : basePageTable;
        let rect = el.getBoundingClientRect();
        let offsetTop = rect.top;// 顶部偏移量
        // while (el.offsetParent) {
        //   offsetTop += el.offsetTop;
        //   el = el.offsetParent;
        // }
        let offsetBottom = 0;// 底部偏移量
        if (this.$refs.basePagination) {
          el = this.$refs.basePagination;
          el = el.$el ? el.$el : el;
          offsetBottom += el.offsetHeight;
          offsetBottom += 6;
        } else {
          offsetBottom += 6;
        }
        this.offsetWindowHeight = window.innerHeight - offsetTop - offsetBottom - 35;
        tableHeight = this.offsetWindowHeight;
      }
      // 自适应表格行数
      let rowHeight = 36;
      if (basePageTable.size === 'mini') {
        rowHeight = 36;
      } else if (basePageTable.size === 'small') {
        rowHeight = 40;
      } else if (basePageTable.size === 'medium') {
        rowHeight = 44;
      }
      if (tableHeight) {
        let tableBodyHeight = tableHeight - 48;
        this.pageSize = parseInt(tableBodyHeight / rowHeight);
        this.pageSizes[0] = this.pageSize;
      }
    }

    if (this.initRows) {
      // 表格初始化查询
      this.getRows();
    }
  },
}
</script>
